import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';

export interface StructuredDataOptions {
  persistent?: boolean;
}

@Injectable({ providedIn: 'root' })
export class StructuredDataService {
  private readonly document = inject(DOCUMENT);

  setLd(id: string, data: object, opts: StructuredDataOptions = {}): void {
    const selector = `script[data-jsonld="${id}"]`;
    const existing = this.document.querySelector<HTMLScriptElement>(selector);
    const node = existing ?? this.document.createElement('script');

    node.setAttribute('type', 'application/ld+json');
    node.setAttribute('data-jsonld', id);
    if (opts.persistent) {
      node.setAttribute('data-persistent', '');
    } else if (node.hasAttribute('data-persistent')) {
      node.removeAttribute('data-persistent');
    }

    node.textContent = JSON.stringify(data);

    if (!existing) {
      this.document.head.appendChild(node);
    }
  }

  removeLd(id: string): void {
    this.document.querySelector(`script[data-jsonld="${id}"]`)?.remove();
  }

  clearTransient(): void {
    const nodes = this.document.querySelectorAll(
      'script[data-jsonld]:not([data-persistent])'
    );
    nodes.forEach((node) => node.remove());
  }
}
